/**
 * Application-wide configuration constants
 * These values are loaded from environment variables
 */

// Environment validation helper
const getEnvVar = (key, defaultValue = '') => {
  const value = import.meta.env[key];
  if (value === undefined && !defaultValue) {
    console.warn(`Environment variable ${key} is not defined`);
  }
  return value || defaultValue;
};

// Application Configuration
export const APP_CONFIG = {
  name: getEnvVar('VITE_APP_NAME', 'Ecomotech ERP'),
  version: getEnvVar('VITE_APP_VERSION', '0.1.0'),
  environment: getEnvVar('VITE_APP_ENV', 'development'),
};

// API Configuration
export const API_CONFIG = {
  baseURL: getEnvVar('VITE_API_BASE_URL', '/api'),
  timeout: parseInt(getEnvVar('VITE_API_TIMEOUT', '30000'), 10),
};

// Authentication Configuration
export const AUTH_CONFIG = {
  tokenKey: getEnvVar('VITE_AUTH_TOKEN_KEY', 'ecomotech_auth_token'),
  refreshTokenKey: getEnvVar('VITE_AUTH_REFRESH_TOKEN_KEY', 'ecomotech_refresh_token'),
  rememberMeKey: 'ecomotech_remember_me',
  userDataKey: 'ecomotech_user_data',
  sessionTimeout: parseInt(getEnvVar('VITE_AUTH_SESSION_TIMEOUT', '3600000'), 10), // 1 hour
  rememberMeExpiry: parseInt(getEnvVar('VITE_AUTH_REMEMBER_ME_EXPIRY', '2592000000'), 10), // 30 days
};

// Feature Flags
export const FEATURE_FLAGS = {
  enableMockAPI: getEnvVar('VITE_ENABLE_MOCK_API', 'true') === 'true',
  enableDebugMode: getEnvVar('VITE_ENABLE_DEBUG_MODE', 'false') === 'true',
  enableAnalytics: getEnvVar('VITE_ENABLE_ANALYTICS', 'false') === 'true',
};

// External Services
export const EXTERNAL_SERVICES = {
  analyticsId: getEnvVar('VITE_ANALYTICS_ID', ''),
  sentryDSN: getEnvVar('VITE_SENTRY_DSN', ''),
};

// Development Configuration
export const DEV_CONFIG = {
  port: parseInt(getEnvVar('VITE_DEV_SERVER_PORT', '4028'), 10),
  host: getEnvVar('VITE_DEV_SERVER_HOST', '0.0.0.0'),
};

// Log configuration on load (development only)
if (FEATURE_FLAGS.enableDebugMode) {
  console.log('🔧 App Configuration:', {
    APP_CONFIG,
    API_CONFIG,
    AUTH_CONFIG,
    FEATURE_FLAGS,
  });
}
